/**
 * Utility functions for handling enriched product data with fallbacks
 */

export const getProductTitle = (product) => {
  return product.meta_title || product.title || 'Product Title';
};

export const getProductDescription = (product) => {
  return product.meta_description || product.description || '';
};

export const getProductKeywords = (product) => {
  if (product.meta_keywords && Array.isArray(product.meta_keywords)) {
    return product.meta_keywords;
  }
  if (typeof product.meta_keywords === 'string') {
    return product.meta_keywords.split(',').map(k => k.trim());
  }
  return [product.brand, product.category_slug?.replace(/-/g, ' '), 'tech deals'].filter(Boolean);
};

export const getProductFeatures = (product) => {
  return product.features || [];
};

export const getProductUseCases = (product) => {
  if (product.use_cases && Array.isArray(product.use_cases)) {
    return product.use_cases;
  }
  if (typeof product.use_cases === 'string') {
    try {
      return JSON.parse(product.use_cases);
    } catch {
      return [];
    }
  }
  return [];
};

export const getProductReviewsSummary = (product) => {
  return product.reviews_summary || 'Customer reviews and ratings for this product.';
};

export const getProductFAQ = (product) => {
  if (product.faq && Array.isArray(product.faq)) {
    return product.faq;
  }
  if (typeof product.faq === 'string') {
    try {
      return JSON.parse(product.faq);
    } catch {
      return [];
    }
  }
  return [];
};

export const getTechieScore = (product) => {
  return product.content_rating ?? (product.rating ? parseFloat(product.rating) * 2 : 7.5);
};

export const getTechieScoreSummary = (product) => {
  return product.techieday_score_summary || product.content_rating_summary || `${getTechieScore(product).toFixed(1)}/10 based on product analysis`;
};

export const getBoughtCount = (product) => {
  return product.bought_count || null;
};